
export default function Products() {
  return (
    <section id="products" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-16">
          <div>
            <h2 className="text-6xl font-serif font-bold text-gray-900 leading-tight">
              Our
              <br />
              Products
            </h2>
          </div>
          <div className="flex items-start lg:pt-4">
            <p className="text-lg text-gray-600 leading-relaxed">
              We develop premium iOS applications focused on security and device optimization. Each product is crafted with attention to detail and user needs.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="bg-blue-50/50 rounded-3xl overflow-hidden group hover:shadow-xl transition-shadow duration-300">
            <div className="aspect-[4/3] w-full overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/a03904573bf05a12e202a354e60dd974.jpg" 
                alt="VPN Solution"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-10">
              <h3 className="text-3xl font-bold text-gray-900 mb-4">VPN Solution</h3>
              <p className="text-gray-600 leading-relaxed">
                Advanced VPN technology providing secure, encrypted connections to protect user privacy and data. Features include multiple server locations, fast connection speeds, and seamless integration with iOS devices for comprehensive online security.
              </p>
            </div>
          </div>

          <div className="bg-emerald-50/50 rounded-3xl overflow-hidden group hover:shadow-xl transition-shadow duration-300">
            <div className="p-10 pb-6">
              <h3 className="text-3xl font-bold text-gray-900 mb-4 text-center">Cleaner App</h3>
            </div>
            <div className="aspect-[4/3] w-full overflow-hidden px-10 pb-10">
              <img 
                src="https://readdy.ai/api/search-image?query=mobile%20cleaner%20app%20interface%20on%20iPhone%20displaying%20storage%20optimization%20with%20circular%20charts%20green%20gradient%20background%20iOS%20design%20showing%20storage%20usage%20cleanup%20categories%20and%20optimization%20options%20modern%20utility%20app&width=800&height=600&seq=product-cleaner-2&orientation=landscape" 
                alt="Cleaner App"
                className="w-full h-full object-cover object-top rounded-2xl group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="px-10 pb-10">
              <p className="text-gray-600 leading-relaxed">
                Intelligent device optimization tool that helps users manage storage, remove unnecessary files, and improve device performance. The app provides detailed insights into storage usage and offers smart cleaning recommendations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
